<template>
  <div class="likert__question__container">
    <header v-if="!sameScale">
      <div class="header__legend">
        <p>
          1 = {{ localItem.scale.minLabel }} / 6 = {{ localItem.scale.maxLabel }} /
          {{ $t('appUser.questionnaire.nsp.name') }} = {{
          $t('appUser.questionnaire.definition.name') }}
        </p>
      </div>
      <div class="header__likert">
        <ul>
          <li v-for="n in radio.labels" :key="n">{{ n }}</li>
        </ul>
      </div>
    </header>
    <section>
      <label :class="{ first__scale : !sameScale, label__error: error }">
        {{ item.definition.question }}
      </label>
      <v-radio-group :row="true"
                     :error-messages="fieldErrors"
                     v-model="localItem.answer.answer"
                     @change="onChange"
      >
        <v-radio v-for="n in radio.values"
                 :key="n"
                 :value="n"
                 color="valid"
        />
      </v-radio-group>
    </section>
  </div>
</template>

<script>
import itemMixin from '@/components/appUser/questionnaires/pageItems/itemMixin'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'QuestionLikertItem',
  mixins: [itemMixin],
  data () {
    return {
      radio: {
        labels: ['1', '2', '3', '4', '5', '6', this.$t('appUser.questionnaire.nsp.name')],
        values: [0, 1, 2, 3, 4, 5, -1]
      },
      sameScale: false
    }
  },
  computed: {
    ...mapGetters('User', [
      'user'
    ]),
    ...mapGetters('UserQuestionnaire', [
      'changePage',
      'lastLikertQuestion',
      'questionnaire'
    ]),
    fieldErrors () {
      const errors = []
      if (!this.$v.localItem.answer.answer.$dirty) return errors
      if (!this.$v.localItem.answer.answer.required) errors.push('Cette question est obligatoire')
      return errors
    },
    error () {
      return this.$v.localItem.answer.answer.$dirty && this.$v.$invalid
    }
  },
  watch: {
    changePage () {
      if (this.changePage) {
        this.$v.$touch()
      }
    }
  },
  validations: {
    localItem: {
      answer: {
        answer: {
          required
        }
      }
    }
  },
  beforeMount () {
    if (this.item.definition !== undefined && this.lastLikertQuestion !== null) {
      this.sameScale = this.lastLikertQuestion.order === (this.item.order - 1) &&
        this.lastLikertQuestion.scale.id === this.item.scale.id
    }

    this.saveLikertQuestion(this.item)
  },
  methods: {
    ...mapActions('UserQuestionnaire', [
      'saveLikertQuestion',
      'sendAnswer'
    ]),
    onChange () {
      if (this.questionnaire.isPublished || this.questionnaire.user === this.user.id) {
        this.sendAnswer({
          questionId: parseInt(this.localItem.value),
          answer: this.localItem.answer,
          likertDefinition: this.localItem.definition
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .likert__question__container {
    display: flex;
    flex-direction: column;

    header {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      min-height: 35px;

      .header__legend {
        p {
          color: rgba(0, 0, 0, 0.54);
          font-size: 14px;
          margin: 0 0 15px 0;
        }
      }

      .header__likert {
        height: 100%;
        display: grid;
        grid-template-columns: 1fr 2fr;
        justify-content: center;
        align-items: center;

        ul {
          grid-column: 2/3;
          height: 100%;
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          padding: 0;

          li {
            list-style: none;
            display: flex;
            justify-content: center;
            align-items: center;
            color: rgba(0, 0, 0, 0.54);
          }
        }
      }
    }

    section {
      display: grid;
      grid-template-columns: 1fr 2fr;
      justify-content: center;
      align-items: center;
      min-height: 70px;

      label {
        color: rgba(0, 0, 0, 0.74);
        height: 100%;
        display: flex;
        align-items: center;
        padding: 10px 0;

        &.label__error {
          color: rgb(255, 82, 82);
        }
      }

      .v-input--selection-controls {
        margin-top: 0;
        padding: 0;
        height: 100%;

        &::v-deep .v-input__control {
          flex: 1 1 auto;
          height: 100%;

          .v-input__slot {
            height: 100% !important;
          }

          .v-input--radio-group__input {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            justify-content: center;
            height: 100%;

            .v-radio {
              margin-right: 0;
              display: flex;
              justify-content: center;

              .v-input--selection-controls__input {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
</style>
